import { Pencil } from 'lucide-react';
import type { PropertyResponse } from '@/shared/api';
import { formatCurrency } from '@/shared/lib/format';
import { BentoFact, BentoTile } from './BentoTile';

export function StammdatenTile({ property }: { property: PropertyResponse }) {
  return (
    <BentoTile
      to="/properties/$id/stammdaten"
      propertyId={property.id}
      icon={<Pencil size={13} strokeWidth={2} />}
      eyebrow="Stammdaten"
      cta="Bearbeiten"
      iconTint="navy"
    >
      <dl className="grid grid-cols-2 gap-x-4 gap-y-3 text-sm">
        <BentoFact label="Typ" value={property.propertyType} />
        <BentoFact label="Zeitzone" value={property.timezone.replace('Europe/', '')} />
        <BentoFact
          label="Gäste"
          value={String(property.occupancyAdults + property.occupancyChildren)}
        />
        <BentoFact label="Räume" value={`${property.bedrooms} BR · ${property.bathrooms} Bad`} />
        <BentoFact
          label="Check-in/-out (Objekt)"
          value={`${property.checkInTime.slice(0, 5)} → ${property.checkOutTime.slice(0, 5)}`}
        />
        <BentoFact
          label="Cleaning"
          value={formatCurrency(property.cleaningFee, property.currency)}
        />
      </dl>
    </BentoTile>
  );
}
